






















import { defineComponent, computed, ref, onMounted } from '@vue/composition-api';
import GongyiCard from '@/components/common/gongyi-card.vue';
import NgoStatis from '@/components/ngo-module/statis.vue';
import BottomDonate from '@/components/ngo-module/bottom-donate.vue';
import { useRoute } from '@/hooks/use-route';
import { useStampStore } from '@/store/stamp';
import { storeToRefs } from 'pinia';
import { language } from '@tencent/ppd-base-libs';
import ExchangeDialog from '@/components/ngo-stamp-module/exchange-dialog.vue';
import { ScreenDialog } from '@tencent/wphk-ui';
import { biBrow } from '@tencent/fit-bi-sdk';

export default defineComponent({
  name: 'NGO',
  components: { GongyiCard, NgoStatis, BottomDonate, ExchangeDialog },
  setup() {
    // 路由
    const route = useRoute();
    const { id } = route.route.params;
    const { isExpiredFlag } = route.route.query;
    // 是否从往期页进入
    const isExpired = +isExpiredFlag === 1;

    const stampStore = useStampStore(); // store
    const { ngoActInfoList, expiredNgoActInfoList } = storeToRefs(stampStore);

    const ngoInfo = computed(() => {
      if (isExpired) {
        return expiredNgoActInfoList.value.find((ele) => ele.key === id);
      }
      return ngoActInfoList.value.find((ele) => ele.key === id);
    }); // NGO 活动信息

    // 语言
    const isEn = ref(language.isEn() as Boolean);

    // 捐贈成功弹窗
    const currentDonateNGO = ref({});
    const exchangeDialog = ref<InstanceType<typeof ScreenDialog> | null>(null);
    const handleShowExchangeDialog = (ngo) => {
      currentDonateNGO.value = ngo;
      exchangeDialog.value?.show();
    };
    onMounted(() => {
      biBrow('detail.page_brow|详情页曝光', {
        fngo_item_name: ngoInfo.value?.name || '',
        fisexpired: isExpired ? '1' : '0',
      });
    });
    return {
      ngoInfo,
      isEn,
      currentDonateNGO,
      exchangeDialog,
      isExpired,
      handleShowExchangeDialog,
    };
  },
});
